import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from './lib/utils';
const Input = React.forwardRef(({ className, type, ...props }, ref) => {
    return (_jsx("input", { type: type, ref: ref, className: cn(
        // Glass-on-dark input: translucent white surface, white text,
        // cyan focus ring. Placeholder uses dimmed white for contrast
        // without shouting.
        'flex h-11 w-full rounded-lg border border-white/15 bg-white/10 px-3 py-2 text-sm text-white shadow-inner shadow-black/20 transition-colors placeholder:text-white/50 focus-visible:border-primary focus-visible:outline-none focus-visible:ring-[3px] focus-visible:ring-primary/30 focus-visible:bg-white/15 disabled:cursor-not-allowed disabled:opacity-50', type === 'search' &&
            '[&::-webkit-search-cancel-button]:appearance-none [&::-webkit-search-decoration]:appearance-none', className), ...props }));
});
Input.displayName = 'Input';
export { Input };
//# sourceMappingURL=input.js.map